import React from "react";
import styles from "./LogoPane.scss";
import { TextLogo } from "../../../graphic/TextLogo";
import { ContentWrapper } from "../../ContentWrapper";

export const LogoPane = () => {
    return (
        <div className={styles.base}>
            <ContentWrapper>
                <div className={styles.logo}>
                    <TextLogo color="contrast" />
                </div>
            </ContentWrapper>
        </div>
    );
};
